module.exports = __webpack_public_path__ + "assets/img/gal_09.377c30d7.jpg";